var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#343434"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2611 17.852C10.2831 17.2687 10.6689 16.7518 11.2199 16.5658L26.6182 11.3568C26.7507 11.3021 26.9335 11.2729 27.1289 11.2803C27.9103 11.3098 28.521 11.9683 28.4915 12.7484C28.4839 12.9507 28.4397 13.1294 28.3572 13.2928L22.0207 28.2138C21.7937 28.7505 21.2506 29.0963 20.6659 29.0742C20.0507 29.051 19.5251 28.6385 19.3574 28.0453L17.5038 21.5719L11.1857 19.2355C10.6097 19.0209 10.238 18.4658 10.2611 17.852ZM27.0999 12.7111L11.6642 17.88L18.3142 20.3926C18.5208 20.4697 18.6794 20.6408 18.7394 20.8526L20.7182 27.6887C20.7362 27.6894 20.7422 27.6771 20.7437 27.6744L27.0999 12.7111Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/Pointer.89987a7fbb06f7c0ca29947eff02e84b.svg";
export { ForwardRef as ReactComponent };